export const Info2 = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99935 17.3332C4.39708 17.3332 0.666016 13.6021 0.666016 8.99984C0.666016 4.39756 4.39708 0.666504 8.99935 0.666504C13.6016 0.666504 17.3327 4.39756 17.3327 8.99984C17.3327 13.6021 13.6016 17.3332 8.99935 17.3332ZM8.99935 2.18166C5.23041 2.18166 2.18117 5.2309 2.18117 8.99984C2.18117 12.7688 5.23041 15.818 8.99935 15.818C12.7683 15.818 15.8175 12.7688 15.8175 8.99984C15.8175 5.2309 12.7683 2.18166 8.99935 2.18166Z"
      fill="currentColor"
    />
    <path
      d="M8.99976 13.3561C8.5831 13.3561 8.24219 13.0152 8.24219 12.5985V8.24244C8.24219 7.82577 8.5831 7.48486 8.99976 7.48486C9.41643 7.48486 9.75734 7.82577 9.75734 8.24244V12.5985C9.75734 13.0152 9.41643 13.3561 8.99976 13.3561Z"
      fill="currentColor"
    />
    <path
      d="M8.99976 6.5381C9.41816 6.5381 9.75734 6.19892 9.75734 5.78052C9.75734 5.36213 9.41816 5.02295 8.99976 5.02295C8.58137 5.02295 8.24219 5.36213 8.24219 5.78052C8.24219 6.19892 8.58137 6.5381 8.99976 6.5381Z"
      fill="currentColor"
    />
    <path
      d="M8.9997 6.72744C8.4694 6.72744 8.05273 6.31077 8.05273 5.78047C8.05273 5.25016 8.4694 4.8335 8.9997 4.8335C9.53001 4.8335 9.94667 5.25016 9.94667 5.78047C9.94667 6.31077 9.53001 6.72744 8.9997 6.72744ZM8.9997 5.21228C8.67773 5.21228 8.43152 5.4585 8.43152 5.78047C8.43152 6.10244 8.67773 6.34865 8.9997 6.34865C9.32167 6.34865 9.56789 6.10244 9.56789 5.78047C9.56789 5.4585 9.32167 5.21228 8.9997 5.21228Z"
      fill="currentColor"
    />
  </svg>
);
